import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { HashLink } from 'react-router-hash-link';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    color: palette.text.primary,
    textDecoration: 'none'
  }
}));

const LinkHash = ({ route, children }) => {
  const classes = useStyles({})
;
  return (
    <HashLink smooth className={classes.root} to={route}>
      {children}
    </HashLink>
  );
};

export default LinkHash;
